import React from 'react';
import styles from './styles.module.scss';
import HeroItem from './HeroItem';

const ListItemDesktop = ({
  data
}) => {
  const renderItem = item => {
    return /*#__PURE__*/React.createElement(HeroItem, {
      key: item.id.toString(),
      className: styles.item,
      item: item
    });
  };

  return /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, data.map(renderItem));
};

export default ListItemDesktop;